import React, { PureComponent } from 'react';
import { Form } from 'react-final-form';
import { getSocial, updateSocial } from '../../../api/users';
import Loader from '../../../atoms/Loader';
import TextField from '../../../components/Form/TextField';

export default class TourLeader extends PureComponent {
  state = {
    loading: true,
    user: this.props.user,
    social: null,
    id: '',
  }

  async componentDidMount() {
    this.setState({
      loading: true,
    });

    getSocial(this.props.id)
      .then(data => {
        this.setState({
          social: data,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  // Accept only number
  validatePhone = value => {
    if (!value) {
      return 'Required';
    }
    if (!/^\d+$/.test(value)) {
      return 'Must be a number';
    }
    return undefined;
  };

  handleSubmit = async (data) => {
    this.setState({
      loading: true,
    });

    updateSocial(this.props.id, data)
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const initialValues = this.state.social;

    return (
      <>
        {initialValues?.photo && (
          <div style={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }} className="user-image">
            <img src={initialValues?.photo} width={400} height={220} alt="user picture" />
          </div>
        )}
        <Form
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <>
              <div className="columns">
                <div className="column">
                  <TextField name="name" placeholder="nome e cognome" label="Nome e Cognome" />
                </div>
                <div className="column">
                  <TextField name="phone" placeholder="telefono" label="Telefono" validate={this.validatePhone} />
                </div>
                <div className="column">
                  <TextField name="photo" placeholder="foto" label="Foto" />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <TextField name="facebook" placeholder="facebook" label="Facebook" />
                </div>
                <div className="column">
                  <TextField name="instagram" placeholder="instagram" label="Instagram" />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <TextField name="description" placeholder="descrizione" label="Descrizione" />
                </div>
              </div>

              <footer>
                <div className="field">
                  <div className="control">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="button is-orange is-large"
                      disabled={submitting || pristine}
                    >
                      Salva
                    </button>
                  </div>
                </div>
              </footer>
            </>
          )}
        />

        {this.state.loading && <Loader />}
      </>
    );
  }
}
